export const site = {
  brand: "吃瓜前排",
  brandEn: "FrontRow Gossip",
  tagline: "选美翻车名场面，前排一次看够",
  description:
    "吃瓜前排专注于整理各大选美赛事里的翻车时刻、尴尬瞬间与搞笑名场面，从评委表情到选手反应，帮你把散落各处的乐子拼成一条完整时间线。",
  email: "hello@chiguaqianpai.example.com",
  wechat: "chiguaqianpai",
  slogan: "不站队、不臆测、只围观名场面",
};

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "翻车现场", to: "/category/fails" },
  { label: "尴尬瞬间", to: "/category/awkward" },
  { label: "搞笑名场面", to: "/category/funny" },
  { label: "评委表情", to: "/category/judge" },
  { label: "关于我们", to: "/about" },
];

export const footerGroups = [
  {
    title: "热门栏目",
    links: [
      { label: "翻车现场", to: "/category/fails" },
      { label: "尴尬瞬间", to: "/category/awkward" },
      { label: "搞笑名场面", to: "/category/funny" },
      { label: "评委表情", to: "/category/judge" },
      { label: "淘汰时刻", to: "/category/elimination" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "内容原则", to: "/about#principle" },
      { label: "联系我们", to: "/about#contact" },
      { label: "吃瓜时间线", to: "/#timeline" },
    ],
  },
];

export const heroAnchors = [
  { label: "本季焦点", href: "#focus" },
  { label: "栏目分类", href: "#categories" },
  { label: "名场面合集", href: "#moments" },
  { label: "吃瓜时间线", href: "#timeline" },
  { label: "常见问题", href: "#faq" },
];